var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.9,68.1c-1.2,2-2.4,3.9-3.6,5.7c8.5,1.9,13.4,5.3,13.4,7.8c0,3.8-11.2,9.5-28.7,9.5c-17.5,0-28.7-5.6-28.7-9.5     c0-2.6,4.9-5.9,13.4-7.8c-1.2-1.8-2.4-3.7-3.6-5.7c-9.4,2.5-16.2,7.1-16.2,13.6c0,10.4,17.7,15.9,35.1,15.9     c17.4,0,35.1-5.4,35.1-15.9C85.1,75.2,78.2,70.6,68.9,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,79.4c7.3-10,23.1-33.6,23.1-50.2c0-14.7-12-26.7-26.7-26.7S23.3,14.4,23.3,29.2c0,16.7,15.8,40.2,23.1,50.2     C48.2,81.9,51.8,81.9,53.6,79.4z M37.2,29.1c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9     C43,42,37.2,36.2,37.2,29.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fb08993293bad63482b1b4732bff43e9.svg";
export { ForwardRef as ReactComponent };